import {trackEvent} from '@hconnect/common/logging/Analytics'
import {useUserContext} from '@hconnect/login'
import {useCallback} from 'react'

import {DowntimeAnalyticsEventName} from '../consts'
import {AnalyticsPayload, DowntimeDashboardAnalyticsEvent} from '../types'

export const useTrackDowntimeDashboardAnalytics = (plantId: string) => {
  const {loggedUser} = useUserContext()
  const userId = loggedUser?.id
  const country = loggedUser?.country

  const trackDowntimeDashboardAnalytics = useCallback(
    (
      eventOrName: DowntimeDashboardAnalyticsEvent | DowntimeAnalyticsEventName,
      data?: AnalyticsPayload
    ) => {
      if (!plantId) return

      const event =
        typeof eventOrName === 'string'
          ? data === undefined
            ? {name: eventOrName}
            : {name: eventOrName, data}
          : eventOrName

      const baseData = {
        product: 'cockpit',
        timestamp: new Date().toISOString(),
        userId,
        plantId,
        country
      }

      if ('data' in event) {
        trackEvent(event.name, {...baseData, ...event.data})
      } else {
        trackEvent(event.name, baseData)
      }
    },
    [country, plantId, userId]
  )

  return useCallback(
    (
      eventOrName: DowntimeDashboardAnalyticsEvent | DowntimeAnalyticsEventName,
      data?: AnalyticsPayload
    ) => trackDowntimeDashboardAnalytics(eventOrName, data),
    [trackDowntimeDashboardAnalytics]
  )
}
